import { getVariationFillColor } from '@gonfalon/flag-variations/getVariationFillColor';
import { capitalize } from '@gonfalon/strings/capitalize';
import clsx from 'clsx';

import Variation from '#components/Variation';
import type { Flag } from '#utils/flags/records/Flag';
import type { Variation as VariationType } from '#utils/flags/records/Variation';
import { FlagPrerequisitesInstructionKind } from '#utils/instructions/prerequisites/types';

import styles from './styles.module.css';

export type PrerequisiteEntryProps = {
  instructionKind: FlagPrerequisitesInstructionKind;
  variationId?: string;
  prerequisiteFlag: Flag;
};

export const PrerequisiteEntry = ({ instructionKind, variationId, prerequisiteFlag }: PrerequisiteEntryProps) => {
  let preposition = '';
  let verb = '';
  switch (instructionKind) {
    case FlagPrerequisitesInstructionKind.ADD_PREREQUISITE:
      verb = 'add';
      preposition = 'with variation';
      break;
    case FlagPrerequisitesInstructionKind.REMOVE_PREREQUISITE:
      verb = 'remove';
      break;
    case FlagPrerequisitesInstructionKind.UPDATE_PREREQUISITE:
      verb = 'update';
      preposition = 'to the variation';
      break;
    default:
      preposition = 'with variation';
  }
  const prereqName = prerequisiteFlag.name;
  const description = capitalize(`${verb} prerequisite flag`.trim());

  let variation: VariationType | undefined;
  let variationIndex = -1;
  if (variationId) {
    variationIndex = prerequisiteFlag.getVariationIndexFromId(variationId);
    variation = prerequisiteFlag.variations.get(variationIndex);
  }
  const ariaLabel = `${description} ${prereqName} ${preposition} ${
    variationIndex > -1 && variation ? variation.getValueString() : ''
  }`;

  return (
    <span className={styles.prerequisiteEntry} aria-label={ariaLabel}>
      <span>
        {description} <span className="u-fw-semibold">{prereqName} </span>
        {preposition}
      </span>
      {variationIndex > -1 && variation && (
        <span className="u-ws-nowrap">
          <Variation
            className={clsx(styles.variationInstructionEntry, 'u-ml-s')}
            key={variationId}
            color={getVariationFillColor(variationIndex)}
            value={variation.getDisplay()}
          />
        </span>
      )}
    </span>
  );
};
